export default __webpack_public_path__ + "images/voltar-ico-blue.svg";